import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { 
  Building2, 
  ShoppingCart, 
  Package, 
  Wallet2, 
  Settings,
  ChevronRight 
} from 'lucide-react';

function ConfigMenu() {
  const navigate = useNavigate();
  const location = useLocation();

  // Función para saber si el botón está activo
  const isActive = (path) => location.pathname === path;

  // Estilos base NovaERP
  const btnBase = "w-full flex items-center justify-between px-5 py-4 mb-2 rounded-2xl transition-all duration-300 group";
  const btnActive = "bg-[#4f46e5] text-white shadow-lg shadow-indigo-500/20";
  const btnInactive = "bg-white border border-slate-100 text-slate-400 hover:bg-slate-50 hover:text-[#4f46e5]";

  const menuOptions = [
    { label: 'Mi Empresa', path: '/sistema/configuracion/empresa', icon: Building2 },
    { label: 'Ventas y Cobros', path: '/sistema/configuracion/ventas', icon: ShoppingCart },
    { label: 'Productos y Stock', path: '/sistema/configuracion/productos', icon: Package },
    { label: 'Finanzas e Impuestos', path: '/sistema/configuracion/finanzas', icon: Wallet2 },
    { label: 'Sistema y Datos', path: '/sistema/configuracion/sistema', icon: Settings },
  ];

  return (
    <div className="space-y-1">
      {menuOptions.map((opt) => {
        const active = isActive(opt.path);
        return (
          <button 
            key={opt.path}
            className={`${btnBase} ${active ? btnActive : btnInactive}`}
            onClick={() => navigate(opt.path)}
          >
            <div className="flex items-center gap-4">
              <opt.icon size={20} className={active ? "text-white" : "text-slate-400 group-hover:text-[#4f46e5]"} strokeWidth={active ? 2.5 : 2} />
              <span className={`text-[13px] font-medium tracking-tight ${active ? 'text-white' : 'text-slate-600'}`}>
                {opt.label}
              </span>
            </div>
            {active && <ChevronRight size={14} className="text-white/50" />}
          </button>
        );
      })}
    </div>
  );
}

export default ConfigMenu;